import { breakdownTokens as _breakdownTokens, consumedTokens as _consumedTokens, contextHealth as _contextHealth, estimateCost as _estimateCost, fitsContext as _fitsContext, getContext as _getContext, getContextWindow as _getContextWindow, getTokenCosts as _getTokenCosts, getUsage as _getUsage, normalizeUsage as _normalizeUsage, percentRemaining as _percentRemaining, pickModelFor as _pickModelFor, remainingContext as _remainingContext, shouldCompact as _shouldCompact, summarizeUsage as _summarizeUsage, tokensToCompact as _tokensToCompact, } from "@tokenlens/helpers/context";
import { defaultCatalog } from "./source.js";
/**
 * @deprecated Prefer getContext/getUsage/getTokenCosts with `{ providers }`. For raw caps use helpers directly.
 */
export function getContextWindow(modelId, opts) {
    const catalog = opts?.catalog ?? defaultCatalog;
    return _getContextWindow(modelId, { catalog });
}
/**
 * @deprecated Prefer getContext/getUsage with `{ providers }`.
 */
export function remainingContext(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _remainingContext({
        modelId: args.modelId,
        usage: args.usage,
        reserveOutput: args.reserveOutput,
        strategy: args.strategy,
        catalog,
    });
}
/**
 * @deprecated Prefer getTokenCosts/getUsage with `{ providers }`.
 */
export function estimateCost(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _estimateCost({ modelId: args.modelId, usage: args.usage, catalog });
}
/**
 * @deprecated Prefer getContext/getUsage with `{ providers }`.
 */
export function fitsContext(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _fitsContext({
        modelId: args.modelId,
        tokens: args.tokens,
        reserveOutput: args.reserveOutput,
        catalog,
    });
}
/**
 * @deprecated Pass `{ catalog }` from `@tokenlens/fetch` (`fetchModels()`) or from `@tokenlens/models` (`getModels()`).
 */
export function percentRemaining(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _percentRemaining({
        modelId: args.modelId,
        usage: args.usage,
        reserveOutput: args.reserveOutput,
        catalog,
    });
}
/**
 * @deprecated Pass `{ catalog }` from `@tokenlens/fetch` (`fetchModels()`) or from `@tokenlens/models` (`getModels()`).
 */
export function shouldCompact(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _shouldCompact({
        modelId: args.modelId,
        usage: args.usage,
        reserveOutput: args.reserveOutput,
        threshold: args.threshold,
        catalog,
    });
}
/**
 * @deprecated Pass `{ catalog }` from `@tokenlens/fetch` (`fetchModels()`) or from `@tokenlens/models` (`getModels()`).
 */
export function tokensToCompact(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _tokensToCompact({
        modelId: args.modelId,
        usage: args.usage,
        reserveOutput: args.reserveOutput,
        targetPercent: args.targetPercent,
        catalog,
    });
}
/**
 * @deprecated Pass `{ catalog }` from `@tokenlens/fetch` (`fetchModels()`) or from `@tokenlens/models` (`getModels()`).
 */
export function contextHealth(args) {
    const catalog = args.catalog ?? defaultCatalog;
    return _contextHealth({
        modelId: args.modelId,
        usage: args.usage,
        reserveOutput: args.reserveOutput,
        catalog,
    });
}
// Pure helpers (no DI) – re-export directly (deprecated)
/** @deprecated Prefer getUsage/getTokenCosts */
export const normalizeUsage = _normalizeUsage;
/** @deprecated Prefer getUsage/getTokenCosts */
export const breakdownTokens = _breakdownTokens;
/** @deprecated Prefer getUsage/getTokenCosts */
export const consumedTokens = _consumedTokens;
/** @deprecated Prefer getContext + filtering externally */
export const pickModelFor = _pickModelFor;
// Back-compat wrapper that injects defaultCatalog when not provided
/** @deprecated Prefer getUsage/getTokenCosts/getContext */
export function summarizeUsage(args) {
    return _summarizeUsage({
        modelId: args.modelId,
        usage: args.usage,
        catalog: args.catalog ?? defaultCatalog,
        reserveOutput: args.reserveOutput,
    });
}
/** @deprecated Internal normalization is automatic; avoid direct use. */
// Note: toModelId is exported from @tokenlens/core and re-exported in index.ts
// Focused surface wrappers with default catalog fallback
export function getTokenCosts(args) {
    return _getTokenCosts({
        modelId: args.modelId,
        usage: args.usage,
        providers: args.providers ?? defaultCatalog,
    });
}
export function getContext(args) {
    return _getContext({
        modelId: args.modelId,
        providers: args.providers ?? defaultCatalog,
    });
}
export function getUsage(args) {
    return _getUsage({
        modelId: args.modelId,
        usage: args.usage,
        providers: args.providers ?? defaultCatalog,
        reserveOutput: args.reserveOutput,
    });
}
//# sourceMappingURL=context.js.map